import { ContextMenuSeparator } from "@/components/ui/context-menu";

import Access from "./access";
import ColorPicker from "./color-picker";
import ConvertToLink from "./convert-to-link";
import RemoveIcon from "./remove-icon";
import SizePicker from "./size-picker";
import TooltipIcon from "./tooltip";

interface Props extends React.ComponentProps<"div"> {
  rightClickedElement: HTMLElement;
}

const IconContextActions: React.FC<Props> = ({ rightClickedElement }) => {
  return (
    <>
      <ColorPicker rightClickedElement={rightClickedElement} />
      <Access rightClickedElement={rightClickedElement} />
      <SizePicker rightClickedElement={rightClickedElement} />
      <TooltipIcon rightClickedElement={rightClickedElement} />
      <ConvertToLink rightClickedElement={rightClickedElement} />
      <ContextMenuSeparator />
      <RemoveIcon rightClickedElement={rightClickedElement} />
    </>
  );
};
export default IconContextActions;
